import { render, staticRenderFns } from "./reporta8.vue?vue&type=template&id=70511f3b&"
import script from "./reporta8.vue?vue&type=script&lang=js&"
export * from "./reporta8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports